







import { Component, Vue } from 'vue-property-decorator';
import LocaleService from '@/services/LocaleService';
import LocaleText from "@/components/LocaleText.vue";
import {TutorialTipInfo, TutorialTipPosition} from "../store/store";

class FadeQueue {
    private el:HTMLElement;
    private queue:TutorialTipInfo[];
    private component:Vue;
    private visible:boolean;
    private timeoutID:number;
    private hasTimeout:boolean;

    public fadeStyle:string = '';

    constructor(el:HTMLElement, component:Vue) {
        this.el = el;
        this.component = component;
        this.queue = [];
        this.visible = false;
        this.timeoutID = 0;
        this.hasTimeout = false;
    }

    public push(s:TutorialTipInfo):void {
        this.queue.push(s);
        if( !this.hasTimeout ) {
            this.process();
        }
    }

    private process():void {
        if( this.hasTimeout ) {
            clearTimeout(this.timeoutID);
            this.hasTimeout = false;
        }
        let s:TutorialTipInfo|undefined = this.queue.shift();
        if( s !== undefined ) {
            if( s.key === '' && this.visible ) {
                // hide
                this.hasTimeout = true;
                this.fadeStyle = 'fadeout';
                this.visible = false;
                console.log(this.el.classList);
            } else if( s.key !== '' && !this.visible ) {
                // show
                this.hasTimeout = true;
                this.fadeStyle = 'fadein';
                this.visible = true;
                this.component.$data.currentTipLocalCopy = s;
            }
        }
        if( this.hasTimeout ) {
            let _instance:FadeQueue = this;
            this.timeoutID = window.setTimeout(() => {
                _instance.process();
            }, 1500);
        }
    }
}

@Component({
    data() { return {
        currentTipLocalCopy: <TutorialTipInfo> { key: '', position: TutorialTipPosition.center },
        fader: undefined
    }},
    components: {LocaleText},
    computed: {
        currentTip():TutorialTipInfo {
            return this.$store.state.tutorialState.currentTip;
        },
        skipLabel():string {
            return LocaleService.getValue(this.$store.state, "algemeen.introductie.startexperience.title");
        },
        verticalStyle():string {
            let tip:TutorialTipInfo = this.$data.currentTipLocalCopy;
            return tip.position;
        },
        fadeStyle():string {
            let fader:FadeQueue = this.$data.fader;
            return fader === undefined ? '' : fader.fadeStyle;
        }
    },
    methods: {
        handleClose():void {
            this.$store.commit('hideAnyTip');
        }
    },
    mounted() {
        this.$data.fader = new FadeQueue(this.$el, this);
    },
    watch: {
        currentTip: function(val:TutorialTipInfo) {
            let fader:FadeQueue = this.$data.fader;
            if( fader !== undefined ) {
                fader.push(val);
            }
        }
    }
})
export default class TutorialOverlay extends Vue {}
